import axios, { AxiosRequestConfig } from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;


// Universal headers generator
const buildHeaders = (customHeaders: Record<string, string> = {}) => {
  const email = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem('userInfo')).email : undefined;
  const token = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem('userInfo')).access : undefined;

  return {
    ...(email && { "X-User-Email": email }),
    ...(token && { Authorization: `Bearer ${token}` }),
    ...customHeaders,
  };
};

// Universal requester
export const apiRequest = async (
  method: "get" | "post" | "put" | "delete",
  path: string,
  data?: any,
  customHeaders: Record<string, string> = {},
  config: AxiosRequestConfig = {}
) => {
  const headers = buildHeaders(customHeaders);
  const options: AxiosRequestConfig = {
    url: `${API_BASE_URL}${path}`,
    method,
    headers,
    data,
    ...config,
  };
  const response = await axios(options);
  return response.data;
};

// Shortcuts
export const apiGet = (path: string, headers?: Record<string, string>) =>
  apiRequest("get", path, null, headers);

export const apiPost = (
  path: string,
  data?: any,
  headers?: Record<string, string>,
  config?: AxiosRequestConfig
) => apiRequest("post", path, data, headers, config);

export const apiPut = (
  path: string,
  data?: any,
  headers?: Record<string, string>,
  config?: AxiosRequestConfig
) => apiRequest("put", path, data, headers, config);

export const apiDelete = (path: string, headers?: Record<string, string>) =>
  apiRequest("delete", path, null, headers);
